/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Newsletter_PlaceholderInputs */

const ja_playdata_home_newsletter_placeholder = /** @type {(inputs: Playdata_Home_Newsletter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const en_playdata_home_newsletter_placeholder = /** @type {(inputs: Playdata_Home_Newsletter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

/**
* | output |
* | --- |
* | "you@example.com" |
*
* @param {Playdata_Home_Newsletter_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_newsletter_placeholder = /** @type {((inputs?: Playdata_Home_Newsletter_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Newsletter_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_newsletter_placeholder(inputs)
	return en_playdata_home_newsletter_placeholder(inputs)
});